var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('logo-wrap'),_c('user-wrap'),(_vm.isCom && _vm.showBell)?_c('bell-wrap',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeBell),expression:"closeBell"}]}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }